import React from "react";
import { FaGithub, FaYoutube } from "react-icons/fa6";
import { PaddingVr } from "../pages/Home/Home";
import Subtitle from "../components/Subtitle";
import { FaExternalLinkAlt } from "react-icons/fa";

const Social = ({ social }) => {
  return (
    <div
      onClick={() => window.open(social.url, "_blank", "noopener")}
      className="socials-container"
      style={{
        height: "auto",
        borderRadius: "7px",
        width: "fit-content",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        padding: "10",
        marginInline: 10,
        // margin: 10,
      }}
    >
      {social.Icon}
      <PaddingVr width={10} />
      <Subtitle>{social.title}</Subtitle>
    </div>
  );
};

const PROJECTS = [
  {
    year: "2024",
    title: "Cueue - Personalized Assistant",
    description:
      "• Android App that capitalizes on notifications to mitigate distractions and foster beneficial habits, addressing concerns regarding productivity and smartphone reliance. \n • Uses free ecosystem of Android Notifications strategically to balance between conntectivity and focus.",
    links: (
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
        }}
      >
        <i>Work In Progress, follow my socials for updates!</i>
      </div>
    ),
  },
  {
    year: "2023",
    title: "Buzpen - Write Once Publish Anywhere...",
    description:
      "• Write Once, Publish Everywhere ! \n • Buzpen lets you publish your blogs from Notion to multiple supported platforms.",
    reportRoute: "/goda-park",
    links: (
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
        }}
      >
        <Social
          social={{
            title: "Buzpen",
            Icon: <FaExternalLinkAlt size={20} />,
            url: "https://buzpen.com/",
          }}
        />
        <Social
          social={{
            title: "YouTube",
            Icon: <FaYoutube size={25} />,
            url: "https://youtu.be/22ryrhTfYq8",
          }}
        />
      </div>
    ),
  },
  {
    year: "2023",
    title:
      "Virtual Guide To Provide Immersive Experience Of Goda Park Using AR/VR",
    description:
      "• Built a Virtual Experience of tourist attraction in our home town of Nashik called Goda Park. \n • 1st Prize in DIPEX-2023 State Level Competition and 2nd prize in college competition and was covered by multiple local newspapers. \n• This project was fully sponsored by Nashik Municipal Smart City Development Corporation.",
    reportRoute: "/goda-park",
  },
  {
    year: "2022",
    title: "BookEx - Online Book Lending/Selling Platform",
    description:
      "Worked On Front-end ( ReactJS ) And Backend (NodeJS/Express) written in TypeScript with 2 more developers. Learned how Authentication / Authorization works. Learned how to use React Hooks and State Management using Context API effectively.",
    reportRoute: "/bookex",
    links: (
      <>
        <Social
          social={{
            title: "Github",
            Icon: <FaGithub size={25} />,
            url: "https://github.com/morya-111",
          }}
        />
      </>
    ),
  },
  {
    year: "2021",
    title: "Pegs Game",
    description:
      "A web-based implementation of Peg Solitaire – Single/Multiplayer. Learned how to optimize component re-renders in ReactJS.",
    reportRoute: "/pegs",
    links: (
      <>
        <Social
          social={{
            title: "Github",
            Icon: <FaGithub size={25} />,
            url: "https://github.com/shreyasg-git/Pegs-Game",
          }}
        />
      </>
    ),
  },
  {
    year: "2020",
    title: "Path-finding Algorithms Visualizer Using Unity 3D",
    description:
      "Learned and implemented the concepts of pathfinding algorithms like BFS, DFS, Dijkstra’s algorithm using C#/Unity.",
    reportRoute: "/unity",
    links: (
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
        }}
      >
        <Social
          social={{
            title: "Github",
            Icon: <FaGithub size={25} />,
            url: "https://github.com/shreyasg-git/PathFinding-Visualizer",
          }}
        />
        <Social
          social={{
            title: "YouTube",
            Icon: <FaYoutube size={25} />,
            url: "https://www.youtube.com/watch?v=TLO3eW0t8YY",
          }}
        />
      </div>
    ),
  },
];

export default PROJECTS;
